// extracted by mini-css-extract-plugin
module.exports = {"headings":"tableHeadings_headings__HY4nJ"};